import { Stack } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { useSupplier } from "../../../../supplierHooks"
import { Grid, Skeleton } from "@mui/material"
import {
    fetchCustomerSalesDetails,
    SupplierCustomerSalesDetailsResponse,
    SupplierCustomerSalesQuery,
} from "../customerSalesApi"
import { DetailedTable } from "../../merchantSales/components/DetailedCategoryTable"

const useStyles = makeStyles()(() => ({
    container: {
        paddingLeft: "3rem",
    },
}))

function transformData(data: SupplierCustomerSalesDetailsResponse) {
    return data.merchants
}

export function DetailedPanel({ shopTypes, customerId }: { customerId: number; shopTypes?: Array<string> }) {
    const { supplierId } = useSupplier()
    const { classes } = useStyles()

    const customerSalesDetailsResult = useApiQuery(fetchCustomerSalesDetails, {
        queryName: SupplierCustomerSalesQuery.CUSTOMER_SALES_FOR_SUPPLIER_DETAILS,
        dependencies: {
            supplierId,
            customerId,
            shopTypes: shopTypes?.join(","),
        },
        select: transformData,
    })

    return (
        <Grid container className={classes.container}>
            <Grid item xs={10}>
                {customerSalesDetailsResult.isLoading ? (
                    <Stack direction="column" spacing="1rem">
                        <Skeleton variant="rectangular" animation="wave" />
                        <Skeleton variant="rectangular" animation="wave" />
                        <Skeleton variant="rectangular" animation="wave" />
                    </Stack>
                ) : (
                    <Stack direction="column" spacing="1rem">
                        {customerSalesDetailsResult.data?.salesByAccount.categories.map((category) => (
                            <DetailedTable
                                isError={customerSalesDetailsResult.isError}
                                isFetching={customerSalesDetailsResult.isFetching}
                                isInitialLoading={customerSalesDetailsResult.isInitialLoading}
                                category={category}
                            />
                        ))}
                    </Stack>
                )}
            </Grid>
        </Grid>
    )
}
